import { useNavigate } from "react-router-dom"
import { setFormValues, setFormValue , resetForm , setPresets } from "../features/formSlice"

const formRoutes = {
    "rental" : "/form/rental",
    "agreement":"/form/rentalAgreement",
    "invoice" : "/form/invoice",
    "tenant":"/form/tenant",
    "lead":"/form/lead",
    "event":"/form/event",
    "eventAgreement":"/form/eventAgreement"
}

const FormNavigator = (dispatch) => {
    const navigate = useNavigate()
    const rental = (id , values= {}) => {
        navigate(formRoutes.rental)
        dispatch(setFormValue({key : 'id' , value : id , ...values}))

    }
    const agreement = (rentalId , tenantId , id , values={}) => {
        navigate(formRoutes.agreement)
        dispatch(setFormValues(tenantId!=-1?{ rentalId  , id , tenantId, ...values}:{rentalId  , id , ...values}))

    }
    const tenant = (id , values={}) => {
        navigate(formRoutes.tenant)
        dispatch(setFormValues({ id , ...values}))

    }

    const lead = (id, values={}) => {
        navigate(formRoutes.lead)
        dispatch(setFormValues({ id , ...values}))
    }

    const invoice = (rentalId , agreementId ,id , values={}) => {
        navigate(formRoutes.invoice)
        dispatch(setFormValues({rentalId , id, agreementId , ...values}))

    }
    const event = (eventId , values={}) => {
        navigate(formRoutes.event)
        dispatch(setFormValues({id:eventId,...values}))
    }
    const eventAgreement = (eventId , rentalId , tenantId , values={} , presets={}, subTitle=undefined) =>{
        navigate(!subTitle ? formRoutes.eventAgreement :`${formRoutes.eventAgreement}?subtitle=${encodeURIComponent(subTitle)}`)
        dispatch(setPresets(presets))
        dispatch(setFormValues({eventId , rentalId , tenantId , ...values}))

    }
    const clearForm = (cache = false , navigateTo = undefined)=>{

        if (navigateTo){
            navigate(formRoutes[navigateTo])
        }
        dispatch(resetForm({cache:cache}))
    }
    return {eventAgreement,event,rental , agreement , tenant , invoice , lead , clearForm}
}


export {FormNavigator}
